import React, { useState, useEffect } from 'react';
import BasicModal from "../Modal";
import AxiosInstance from '../Axios';
import { CBadge, CListGroup, CListGroupItem, CButton, CIcon } from '@coreui/react';
import { cilTrash } from '@coreui/icons';
import { confirmAlert } from 'react-confirm-alert';
import { Link } from 'react-router-dom';
import VariationsCreateForm from './VariationsCreateForm';

// Варіації
const Variations = (props) => {
    // console.log("Variations props", props);
    const [showModal, setShowModal] = useState(true);
    // Текст для popup
    const popupTextSuccess = "Варіація видалена";

    const actionShowModal = (rez) => {
        setShowModal(rez);
        if (!rez)
            getParent();
    };
    const [varItem, setVarItem] = useState(false);
    // console.log("varItem", varItem);
    const getParent = async () => {
        let res = await AxiosInstance.get(`/attribute_items?attribute.id=${props.parent}&pagination=false`, { headers: { 'accept': 'application/json' } }).then((response) => {
            console.log("getParent response", response);
            setVarItem(response.data)
        });
    };

    useEffect(() => {
        getParent();
    }, [props]);

    function Deleted(row) {
        confirmAlert({
            title: 'Ви впевнені що хочите видалити цей пункт ?',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Так',
                    onClick: () => {
                        const response = AxiosInstance.delete('/attribute_items/' + row.id).then((response) => {
                            // Popup про успішні зміни
                            props.toastifySuccess(popupTextSuccess);
                            getParent();
                        });
                    }
                },
                {
                    label: 'Ні',
                    onClick: () => {
                        return;
                    }
                }
            ]
        });
    };

    return (
        <>
            <div className='row mb-2'>
                <div className='col'><h3>Варіації</h3></div>
                <div className='col d-flex justify-content-end'>
                    <BasicModal
                        show={showModal}
                        actionShowModal={actionShowModal}
                        title={`Створіть варіацію #${props.parent} ${props.parent_name}`}
                        content={
                            <VariationsCreateForm
                                data={undefined}
                                actionShowModal={actionShowModal}
                                parent={props.parent}
                                toastifySuccess={props.toastifySuccess}                            />
                        }
                    />
                </div>
            </div>

            {
                (varItem != false && varItem.length > 0) ?
                    <CListGroup className="mb-3">
                        {
                            varItem.map((v, k) => {
                                return (
                                    <CListGroupItem key={k} className="d-flex justify-content-between align-items-center">
                                        <Link to={`/attributes/variations/update/${v.id}`} >
                                            {v.name}
                                        </Link>
                                        <CButton color="danger" variant="outline" onClick={() => { Deleted(v) }}>
                                            Видалити
                                        </CButton>
                                    </CListGroupItem>
                                )
                            })
                        }
                    </CListGroup>
                    :
                    <p className="ml-3">Варіацій не знайдено</p>
            }
        </>
    );
};

export default Variations;